import { CreateApiResponse, FetchApiResponse } from "redux/types";

export enum FundingDetailsReduxTypes {
    FUNDING_DETAILS_REPORT = "@@auth/FUNDING_DETAILS_REPORT",
    FUNDING_DETAILS_REPORT_SUCCESS = "@@auth/FUNDING_DETAILS_REPORT_SUCCESS",
    FUNDING_DETAILS_REPORT_ERROR = "@@auth/FUNDING_DETAILS_REPORT_ERROR"
}

export type FundingDetailsActionDispatch = {
    type: | FundingDetailsReduxTypes.FUNDING_DETAILS_REPORT
    payload: any;
}

export type FundingDetailsReducerDispatch = {
    type: | FundingDetailsReduxTypes.FUNDING_DETAILS_REPORT
    | FundingDetailsReduxTypes.FUNDING_DETAILS_REPORT_SUCCESS
    | FundingDetailsReduxTypes.FUNDING_DETAILS_REPORT_ERROR
    payload: {
        data?: FetchApiResponse<FundingDetails>
        error?: string
    }
}

export type FundingDetails = {
    updatedOn: string;
    createdOn: string;
}

export type CreateFundingDetails = {
    startDate: string,
    endDate: string
}

export type CreateFundingDetailsRequest = {
    payload: CreateFundingDetails,
    type: string
}

export type CreateFundingDetailsReduxState = {
    loading?: boolean,
    data?: CreateApiResponse<FundingDetails>
    error?: string | null
}